import UserRole from 'src/types/UserRoles';

export enum StageType {
  dev = 'DEV',
  qa = 'QA',
  prod = 'PROD',
}

export enum NotificationType {
  Important = 'important',
  Message = 'message',
  Update = 'update',
  Other = 'other',
}

export const NotificationColors = {
  [NotificationType.Important]: 'red',
  [NotificationType.Message]: 'blue',
  [NotificationType.Update]: 'orange',
  [NotificationType.Other]: 'gray',
};

export interface AppNotification {
  _id: string;
  updatedAt?: string; // ISO datetime, explicitly set by editor when notification content should resurface
  baseUpdatedAt?: string; // updatedAt of the base language document, inherited by translations
  title: string;
  slug: string;
  shortInfo?: string;
  messageType: NotificationType;
  description: any; // assuming 'blockContent' can be of any structured type
  added: string; // dateTime in ISO format
  startTime?: string; // datetime in ISO format
  endTime?: string; // datetime in ISO format
  roles?: UserRole[];
  countries?: string[];
  isRead?: boolean;
}

export interface NotificationStorageItem {
  id: string;
  date: string;
}
